import { SearchableSelect } from "@/components/ui/searchable-select";
import { cn } from "@/lib/utils";

import type { SelectOption } from "../types";

interface SearchableSelectCellProps {
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[]; // Options to display in { value, label } format
  isEdited: boolean;
  placeholder?: string;
  disabled?: boolean;
  isLoading?: boolean;
}

/**
 * Searchable select dropdown cell editor for EditableTable
 * Useful for large option lists (e.g., player selection)
 * Provides visual feedback for edited state via wrapper div
 */
export function SearchableSelectCell({
  value,
  onChange,
  options,
  isEdited,
  placeholder = "Select...",
  disabled = false,
  isLoading = false,
}: SearchableSelectCellProps) {
  return (
    <div
      className={cn(
        "rounded-sm transition-all border-[3px] border-transparent",
        isEdited ? "border-blue" : "",
      )}
    >
      <SearchableSelect
        value={value || ""}
        onValueChange={onChange}
        options={options}
        placeholder={placeholder}
        disabled={disabled}
        isLoading={isLoading}
        buttonClassName="border-gray-300 border"
      />
    </div>
  );
}
